export default class LocalFsService {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return this._instance = new LocalFsService();
	}

	download(url) {
		if (!url) return;

		var element = document.createElement('a');
		element.setAttribute('href', url);
		element.setAttribute('target', 'blank');
		element.style.display = 'none';
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
	}

	save(data, title) {
		if (!data) return;

		var element = document.createElement('a');
		var uriContent = URL.createObjectURL(new Blob([JSON.stringify(data, null, 4)], { type: 'text/plain;charset=utf-8' }));
		element.setAttribute('href', uriContent);
		element.setAttribute('download', (title || data.title) + '.json');
		element.style.display = 'none';
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
	}

	load(files) {
		return new Promise((r, rj) => {
			var reader = new FileReader();
			reader.onload = () => {
				try {
					r(JSON.parse(String(reader.result)));
				} catch(e) {
					rj(e);
				}
			};
			reader.readAsText(files[0]);
		});
	}
}
